import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { CurrentUser } from "@common/auth/current-user";
import { SubscriptionStepperState } from "@common/billing/subscriptions/subscription-stepper-state.service";
import { Plan } from "@common/core/types/models/Plan";

@Component({
  selector: "features-table",
  templateUrl: "./features-table.component.html",
  styleUrls: ["./features-table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesTableComponent implements OnInit {
  public hasRecommendedPlan = false;
  @Output() selected = new EventEmitter();
  defaultPlan:any=[]
  selectedCru:any
  selectedYear:any
  @Input() year;
    @Input() cur;

  tableData = [
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
    {
      link: "Branded domains",
      basic: "up to 1",
      startUp: "up to 1",
      growth: "up to 1",
      custom: "up to 1",
    },
  ];

  constructor(
    public state: SubscriptionStepperState,
    public currentUser: CurrentUser
  ) {}

  ngOnInit(): void {
    this.hasRecommendedPlan =
      this.state.plans.filter((plan) => plan.recommended).length > 0;
  }

  public selectPlan(plan: Plan) {
    this.state.selectInitialPlan(plan);
    // fire event on next render to avoid race conditions
    setTimeout(() => this.selected.emit(plan));
  }

  public getAllPlans() {
    this.defaultPlan=[]
    console.log('planData', this.selectedCru)
    console.log('year', this.selectedYear )
    this.state.plans.forEach((pl)=>{
        if(!this.selectedCru && !this.selectedYear)  {
          if(pl.currency === "INR" && pl.interval  === "month" ){
            this.defaultPlan.push(pl);
          }
        }
        if(this.selectedCru && !this.selectedYear){
            if(pl.currency === this.selectedCru &&  pl.interval  === "month" ){
                this.defaultPlan.push(pl)
            }
        }
        if(!this.selectedCru && this.selectedYear){
            if(pl.currency === "INR" &&  pl.interval  === this.selectedYear.toLowerCase() ){
                this.defaultPlan.push(pl)
            }
        }
        if(this.selectedCru && this.selectedYear){
            if(pl.currency === this.selectedCru &&  pl.interval  === this.selectedYear.toLowerCase() ){
                this.defaultPlan.push(pl)
            }
        }
    })
    console.log('this.defaultPlan', this.defaultPlan)
}

  public userSubscribedToPlan(plan: Plan): boolean {
    if (
      this.state.mode !== "pricing" &&
      plan.free &&
      !this.currentUser.model$?.value?.subscriptions?.length
    ) {
      return true;
    }
    return !!this.currentUser.getSubscription({ planId: plan.id });
  }

  public selectPlanButtonText(plan: Plan) {
    if (this.userSubscribedToPlan(plan)) {
      return "Your Current Plan";
    } else if (plan.free && this.state.mode === "pricing") {
      return "Get Started";
    } else {
      return "Choose Plan";
    }
  }

  shouldDisablePlanSelection(plan: Plan) {
    return (
      (this.state.mode !== "pricing" && plan.free) ||
      this.userSubscribedToPlan(plan)
    );
  }
}
